import type { InferType } from 'form';
import { CircularProgress, Page, Section, Typography } from 'ui';
import { AddBoxOutlined } from 'ui/icons';

import { MaterialProductUpdateForm } from '../../components/MaterialProductUpdateForm/MaterialProductUpdateForm';
import { useGetMaterialProductDetails } from '../../hooks/useGetMaterialProductDetails/useGetMaterialproductDetails';
import type { MaterialProductSchema } from '../schema';

export type UpdateFormValues = InferType<typeof MaterialProductSchema>;

export const MaterialProductDetails = () => {
  const materialProductDetails = useGetMaterialProductDetails();

  return (
    <Page>
      <Section title="Material Product" icon={AddBoxOutlined}>
        {materialProductDetails.isLoading ? <CircularProgress /> : null}
        {!materialProductDetails.isLoading && materialProductDetails.data ? (
          <MaterialProductUpdateForm
            materialProductData={materialProductDetails.data}
            materialProductId={Number(materialProductDetails.id)}
          />
        ) : null}
        {!materialProductDetails.isLoading && !materialProductDetails.data && (
          <Typography>Material Product not found</Typography>
        )}
      </Section>
    </Page>
  );
};
